export enum CastType {
  CHROMECAST = 'chromecast',
  AIRPLAY = 'airplay',
}
